const MedicalRecordReportWeb = () => {
  return <></>;
};

export default MedicalRecordReportWeb;
